import { createSlice } from '@reduxjs/toolkit';


const deLanguage = {
  "lang": "de",
  "welcome": "Willkommen",
  "hello": "Hallo",
  "documentType": "Dokumenten-Typ",
  "analysis": "Analyse",
  "selectOneHeader": "Dokumenten-Typ 1: Ausschreibungen",
  "selectTwoHeader": "Dokumenten-Typ 2: Werkverträge",
  "selectOneDescription": "Analyse und Zusammenfassung einer Ausschreibung und der zugehörigen Unterlagen (Vorspann, Leistungsverzeichnis) anhand definierter Fragestellungen",
  "selectTwoDescription": "Analyse, Offertenvergleich und Zusammenfassung eines Werkvertrages und der zugehörigen Unterlagen (Leistungsverzeichnis) anhand definierter Fragestellungen",
  "uploadHeader": "Dokumenten-Typ [1]: Analyse von Ausschreibungen",
  "uploadDropZone": "Ziehen und Ablegen von Dateien zum Hochladen",
  "select": "Auswählen",
  "documentAnalysis": "Dokumenten-Analyse",
  "accountSettings": "Account-Einstellungen",
  "documentSettingsOne" : "1 Einstellungen",
  "documentSettingsSecond" : "2 Einstellungen",
  "exemplaryQuestion" : "Beispielhafte Frage/Eingabeaufforderung",
  "questionKindDocument": "Welche Dokumente möchten Sie heute analysieren?",
  "dragDrop": "Ziehen und Ablegen von Dateien zum Hochladen",
  "browseFiles": "Dateien durchsuchen",
  "selectedFiles": "Ausgewählte Dateien",
  "noFilesSelected": "Keine Dateien ausgewählt",
  "language": "Sprache",
  "moreInformationForQuality": "Weitere Informationen für eine bessere Antwortqualität",
  "goBack": "Zurück",
  "startSummary": "Zusammenfassung erstellen",
  "startChat": "Chat starten",
  "addQuestionPrompt": "Frage hinzufügen",
  "loading": "Laden...",
  "settingsDocumentTypeOne": "Einstellungen für Dokumenten-Typ 1 “Ausschreibungen”",
  "settingsDocumentTypeTwo": "Einstellungen für Dokumenten-Typ 2 “Werkverträge”",
  "discard": "Änderungen verwerfen",
  "saveSettings": "Einstellungen speichern",
  "docSummary": "Zusammenfassung von DocAI",
  "docType": "Dokumenttyp",
  "uploadedFiles": "Hochgeladene Dateien",
  "summaryGeneratedOn": "Zusammenfassung erstellt am",
  "summaryGeneratedBy": "Zusammenfassung erstellt von",
  "questionPrompt": "Frage/Aufforderung",
  "answerNotFound": "Antwort: Nicht gefunden",
  "answerTo": "Antwort auf",
  "references": "-Referenzen",
  "disclaimerText": "Haftungsausschluss: DocAI kann Fehler machen. Bitte überprüfen Sie wichtige Fakten.",
  "logoutbtn": "Ausloggen",
  "settingsUpdatedToast": "Einstellungen erfolgreich aktualisiert",
  "fileUploadedToast": "Datei erfolgreich hochgeladen",
  "fileUploadingErrorToast": "Fehler beim Hochladen der Datei",
  "fileAlreadyToast": "ist bereits hochgeladen!",
  "selectFileUploadToast": "Bitte wählen Sie eine Datei zum Hochladen aus!",
  "startChatToast": "Bitte wählen Sie eine Datei zum Hochladen aus",
  "uploadeFileTypeCheckToast": "Laden Sie nur PDF- und DOC-Dateien hoch",
  "systemPromptOne": 'Tonfall des großen Sprachmodells: Sie sind ein Analytiker ...',
  "systemPromptSecond": 'Tonfall des großen Sprachmodells: Sie sind ein Analytiker ...',
  "downloadPDF": "PDF Herunterladen",
  "logoutPrompt": "Sind Sie sicher, dass Sie sich abmelden möchten?",
  "yesLogout": "Ja",
  "noLogout": "NEIN",
  "addQuestion": "Bitte! Fragen hinzufügen",
  "filesLimitException": "Sie können jeweils nur bis zu 5 Dateien hochladen",
  "fileSizeException": "Eine oder mehrere Dateien überschreiten die 10-MB-Grenze",
  "totalFileSizeException": "Die Gesamtgröße aller ausgewählten Dateien sollte 20 MB nicht überschreiten"
};
const enLanguage = {
  "lang": "en",
  "welcome": "Welcome",
  "hello": "Hello",
  "documentType": "Document Type",
  "analysis": "Analysis",
  "selectOneHeader": "Document Type 1: Invitations to tender",
  "selectTwoHeader": "Document Type 2: Contracts for work",
  "selectOneDescription": "Analysis and summary of a tender and the associated documents (preamble, specifications) based on defined questions",
  "selectTwoDescription": "Analysis, comparison of offers and summary of a work contract and the associated documents (specifications) based on defined questions",
  "uploadHeader": "Document Type [1]: Analysis of invitations to tender",
  "uploadDropZone": "Ziehen und legen Sie Ihre Dateien hier ab",
  "select": "Select",
  "documentAnalysis": "Document Analysis",
  "accountSettings": "Account Settings",
  "documentSettingsOne" : "1 Settings",
  "documentSettingsSecond" : "2 Settings",
  "exemplaryQuestion": "Exemplary Question / Prompt",
  "questionKindDocument": "What kind of document do you want to analyze today?",
  "dragDrop": "Ziehen und legen Sie Ihre Dateien hier ab",
  "browseFiles": "Browse your files",
  "selectedFiles": "Ausgewählte Dateien",
  "noFilesSelected": "No files selected",
  "language": "Language",
  "moreInformationForQuality": "More information for advanced answer quality",
  "goBack": "Go Back",
  "startSummary": "Start Summary",
  "startChat": "Start Chat",
  "addQuestionPrompt": "Add Question / Prompt",
  "loading": "Loading...",
  "settingsDocumentTypeOne": "Settings for Document Type 1 “Invitations to tender”",
  "settingsDocumentTypeTwo": "Settings for Document Type 2 “Contracts for Work”",
  "discard": "Discard",
  "saveSettings": "Save Settings",
  "docSummary": "DocAI Summary",
  "docType": "Document Type",
  "uploadedFiles": "Uploaded Files",
  "summaryGeneratedOn": "Summary generated on",
  "summaryGeneratedBy": "Summary generated by",
  "questionPrompt": "Question/Prompt",
  "answerNotFound": "Answer: Not Found",
  "answerTo": "Answer to",
  "references": "-References",
  "disclaimerText": "Disclaimer : DocAI can make mistakes. Consider checking important facts.",
  "logoutbtn": "Log-out",
  "settingsUpdatedToast": "Settings updated successfully",
  "fileUploadedToast": "File uploaded successfully",
  "fileUploadingErrorToast": "Error uploading file",
  "fileAlreadyToast": "is already uploaded!",
  "selectFileUploadToast": "Please select a file to upload!",
  "startChatToast": "Please select a file to upload before start chat!",
  "uploadeFileTypeCheckToast": "Upload only PDF and DOC files!",
  "systemPromptOne": 'Large Language Model Tone: "You are an analyst..."',
  "systemPromptSecond": 'Large Language Model Tone: "You are an analyst..."',
  "downloadPDF": "Download PDF",
  "logoutPrompt": "Are you sure you want to Log-out?",
  "yesLogout": "Yes",
  "noLogout": "No",
  "addQuestion": "Please! Add Questions",
  "filesLimitException": "You can only upload up to 5 files at a time",
  "fileSizeException": "One or more files exceed the 10 MB limit",
  "totalFileSizeException": "The total size of all selected files should not exceed 20 MB"
};

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: {},
    promptSettings: [],
    systemPrompt: deLanguage.systemPromptOne,
    systemPromptTwo: deLanguage.systemPromptSecond,
    languageSetting: deLanguage,
    loading: false,
    notification: '',
    isGetPrompt: false,
    isGetPromptTwo: false,
    uploadProgress: 0,
    isUploading: false,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setSystemPrompt: (state, action) => {
      state.systemPrompt = action.payload;
    },
    setSystemPromptTwo: (state, action) => {
      if (action.payload === null) {
        // state.systemPromptTwo = 'Large Language Model Tone: "You are an analyst..."';
        state.systemPromptTwo = `${enLanguage.systemPromptOne}`;
      } else {
        state.systemPromptTwo = action.payload;
      }
    },
    isPromptGet : (state, action) => {
      state.isGetPrompt = false;
      if(action.payload.length <= 0){
        if(localStorage.getItem('language') === 'de'){
          state.systemPrompt = deLanguage.systemPromptOne;
        } else if(localStorage.getItem('language') === 'en'){
          state.systemPrompt = enLanguage.systemPromptOne;
        }
        state.isGetPrompt = false;
      } else{
        state.isGetPrompt = true;
      }
    },
    isPromptGetTwo : (state, action) => {
      state.isGetPromptTwo = false;
      if(action.payload.length <= 0){
        if(localStorage.getItem('language') === 'de'){
          state.systemPromptTwo = deLanguage.systemPromptSecond;
        } else if(localStorage.getItem('language') === 'en'){
          state.systemPromptTwo = enLanguage.systemPromptSecond;
        }
        state.isGetPromptTwo = false;
      } else{
        state.isGetPromptTwo = true;
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    clearNotification: (state) => {
      state.notification = '';
    },
    setNotification: (state, action) => {
      state.notification = action.payload;
    },
    changeLanguage: (state, action) => {
      if (action.payload === "de") {
        state.languageSetting = deLanguage;
        localStorage.setItem('language', "de");
        if(state.isGetPrompt === false) {
          state.systemPrompt = `${deLanguage.systemPromptOne}`;
        }
        if(state.isGetPromptTwo === false) {
          state.systemPromptTwo = `${deLanguage.systemPromptSecond}`;
        }
      } else {
        state.languageSetting = enLanguage;
        localStorage.setItem('language', "en");
        if(state.isGetPrompt === false) {
          state.systemPrompt = `${enLanguage.systemPromptOne}`;
        }
        if(state.isGetPromptTwo === false) {
          state.systemPromptTwo = `${enLanguage.systemPromptSecond}`;
        }
      }
    },
    setPromptSettings: (state, action) => {
      state.promptSettings = []
      for (let i = 0; i < action.payload.length; i++) {
        state.promptSettings.push(action.payload[i]);
      }
    },
    removePromptSettings: (state, action) => {
      state.promptSettings = state.promptSettings.filter((question) => question.ID !== action.payload);
    },
    updatePromptSettings: (state, action) => {
      if (action.payload.ID === 0) {
        let maxId = 0;
        for (let i = 0; i < state.promptSettings.length; i++) {
          if (state.promptSettings[i].ID > maxId) {
            maxId = state.promptSettings[i].ID;
          }
        }
        action.payload.ID = maxId + 2;
        state.promptSettings.push(action.payload);
      }
      else{
        for (let i = 0; i < state.promptSettings.length; i++) {
          if (state.promptSettings[i].ID === action.payload.ID) {
            state.promptSettings[i].Question = action.payload.Question;
          }
        }
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, setPromptSettings, updatePromptSettings, removePromptSettings, changeLanguage, setSystemPrompt, setSystemPromptTwo, setLoading, setNotification, isPromptGet, isPromptGetTwo } = userSlice.actions;

export default userSlice.reducer;
